import type { CoreSignals, CoreState, DragInfo } from "@/client/core/Core.api";

export const createCoreEventHandlers = (state: CoreState, signals: CoreSignals) => {
    window.addEventListener("resize", () => {
        state.windowShape = { w: window.innerWidth, h: window.innerHeight };
        signals.windowShape.notify(state.windowShape);
    });

    let dragCounter = 0;
    const setDragInfo = (dragInfo: DragInfo | undefined) => {
        const wasDragging = state.dragInfo !== undefined;
        const isDragging = dragInfo !== undefined;
        if (wasDragging !== isDragging) {
            state.dragInfo = dragInfo;
            signals.dragInfo.notify(dragInfo);
        }
    };
    document.addEventListener("dragenter", (event) => {
        event.preventDefault();
        dragCounter++;
        setDragInfo({ types: Array.from(event.dataTransfer?.types ?? []) });
    });
    document.addEventListener("dragleave", (event) => {
        dragCounter--;
        if (dragCounter === 0) {
            setDragInfo(undefined);
        }
        // Reset counter if drag left the window to prevent desync on re-entry
        if (event.relatedTarget === null) {
            dragCounter = 0;
        }
    });
    document.addEventListener("dragover", (event) => {
        event.preventDefault();
    });
    document.addEventListener("drop", (event) => {
        event.preventDefault();
        dragCounter = 0;
        setDragInfo(undefined);
    });
};
